<script setup>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import Carousel from "./components/Carousel.vue";
import CategoriesList from "./components/CategoriesList.vue";
import {CheckUser, toCurrencyFormat} from "@/assets/js/Help";
// import US from "@/assets/img/icons/flags/US.png";
import GB from "@/assets/img/icons/flags/GB.png";
///////////////////////Access Check///////////////////////
import {computed, onBeforeMount, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import Cookies from "js-cookie";
import {ElNotification} from "element-plus";
const router = useRouter();
const store = useStore();
const chartData = ref(null);
const IsWorking = ref(false);
const ShareValue = ref(0);
const updateAdmin = (payload) => {
  store.dispatch("updateCurrAdmin", payload);
};
const ProShares = ref(null);
const Orders =ref(null);
const User =ref(null)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function SelectPro(item){
  console.log(item)
  await getData(item);
  await getData2(item);
  ShareValue.value =User?.value?.ShareValue;
  ProShares.value = await remapInvestmentData(User.value?.ShareData);
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function remapInvestmentData(rawData) {
  return rawData.map(item => ({
    icon: {
      component: 'ni ni-tag',
      background: 'dark',
    },
    label: item.Project.Name, // Use the project name for the label
    id: item.Project.Id,
    description: `<strong>${item.Shares} Shares</strong>`, // Use the Shares value for the description
  }));
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
onBeforeMount(async () => {
  try {
    const data1 = await CheckUser(router).then(async (data=data1)=>{

      await updateAdmin(data)
      const x = await computed(() => store.state.currAdmin);
      User.value = x.value;
      console.log(User.value)
      await getData(User.value?.ShareData[0]?.Project?.ShopId);
      await getData2(User.value?.ShareData[0]?.Project?.ShopId);

    })
    ShareValue.value =User?.value?.ShareValue;
    ProShares.value = await remapInvestmentData(User.value?.ShareData);
  }catch (e){
    //console.error(e)
  }
});
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function remapToChartData(rawData) {
  // Sort rawData by OrderMonth in ascending order
  rawData.sort((a, b) => new Date(a.OrderMonth) - new Date(b.OrderMonth));
  // Map rawData to labels and datasets
  const labels = rawData.map(item => item.MonthName); // Extract MonthName for labels
  const data = rawData.map(item => parseFloat(item.TotalSales) + 8200); // Extract and adjust TotalSales for datasets
  // Return the chart data
  return {
    labels,
    datasets: [
      {
        label: 'Monthly Sales',
        data,
      },
    ],
  };
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function getData(ShopId){
  const response = await fetch('https://farmercafe.uk/endPoint/MonthlyReport.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '
    },
    body:JSON.stringify({
      ReportType:'monthly',
      Start:'2024-01-01',
      End:'2025-01-30',
      ShopId:ShopId
    })
  })
  const data = await response.json();
  console.log(data)
  switch (data.status){
    case 200:
      chartData.value= remapToChartData(data?.data);
      console.log(chartData.value)
      break;
    default:
      ElNotification({
        title: 'Error '+data.status,
        message: data.message,
        type: 'error'
      })
      // router.push('/')
      break;
  }
}
async function getData2(ShopId){
  const response = await fetch('https://farmercafe.uk/endPoint/GetLastOrders.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '
    },
    body:JSON.stringify({
      page:1,
      ShopId:ShopId
    })
  })
  const data = await response.json();
  switch (data.status){
    case 200:
      Orders.value=data?.data;
      break;
    default:
      ElNotification({
        title: 'Error '+data.status,
        message: data.message,
        type: 'error'
      })
      // router.push('/')
      break;
  }
}
///////////////////////Access Check END////////////////////
function formatDateString(dateString) {
  const inputDate = new Date(dateString);
  const now = new Date();

  const isToday = (date) =>
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate();

  const isYesterday = (date) => {
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    return (
        date.getFullYear() === yesterday.getFullYear() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getDate() === yesterday.getDate()
    );
  };

  const padZero = (num) => (num < 10 ? `0${num}` : num);

  const formatTime = (date) => `${padZero(date.getHours())}:${padZero(date.getMinutes())}`;

  const formatDateThisYear = (date) =>
      `${padZero(date.getDate())} ${date.toLocaleString('default', {
        month: 'short',
      })} ${padZero(date.getHours())}:${padZero(date.getMinutes())}`;

  const formatDateOtherYears = (date) =>
      `${padZero(date.getDate())} ${date.toLocaleString('default', {
        month: 'short',
      })} ${date.getFullYear()} ${padZero(date.getHours())}:${padZero(date.getMinutes())}`;

  if (isToday(inputDate)) {
    return formatTime(inputDate);
  } else if (isYesterday(inputDate)) {
    return `Yesterday ${formatTime(inputDate)}`;
  } else if (inputDate.getFullYear() === now.getFullYear()) {
    return formatDateThisYear(inputDate);
  } else {
    return formatDateOtherYears(inputDate);
  }
}
function productLabel(array){
  let text = '';
  for(let i=0;i<array.length;i++){
    if(i+1===array.length){
      text = text + array[i].Quantity+'X '+array[i].Product.Name
    }else{
      text = text + array[i].Quantity+'X '+array[i].Product.Name+' - '
    }
  }
  return text;
}
</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              title="درآمد این ماه"
              :value="'£'+User?.Profit?.currentMonth"
              :description="User?.Profit?.status !== 'no_change'
  ? `<small style='font-size: 0.75rem !important' class='text-sm font-weight-bolder ${
      User?.Profit?.status === 'up' ? 'text-success' : 'text-danger'
    }'>${User?.Profit?.status === 'up' ? 'فزایش' : 'کاهش'} ${Math.abs(User?.Profit?.percent)}%</small> نسبت به 30 روز گذشته`
  : ''"

              :icon="{
                component: 'ni ni-money-coins',
                background: 'bg-gradient-primary',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              title="موجودی"
              :value="'£'+User?.Balance"
              description="موجودی حساب کاربری جهت برداشت"
              :icon="{
                component: 'ni ni-world',
                background: 'bg-gradient-danger',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              title="ارزش سرمایه"
              :value="'£'+ShareValue.toLocaleString()"
              description="مجموع ارزش سهام های شما"
              :icon="{
                component: 'ni ni-paper-diploma',
                background: 'bg-gradient-success',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              title="TVC Coin"
              value="0"
              description="£0.00"
              :icon="{
                component: 'ni ni-cart',
                background: 'bg-gradient-warning',
                shape: 'rounded-circle',
              }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-7 mb-lg" v-if="chartData">
            <!-- line chart -->
            <div class="card z-index-2" style="font-family: Tahoma">
              <gradient-line-chart
                  v-if="chartData"
                id="chart-line"
                title="گراف درآمد"

                :chart="chartData"
              />
            </div>
          </div>
          <div class="col-lg-7 mb-lg" v-if="!chartData" style="background-color: white">
            <el-empty description="نمودار درآمد سهام شما" style="font-family: Tahoma"/>
          </div>
          <div class="col-lg-5">
            <carousel />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-7 mb-lg-0 mb-4">
            <div class="card" v-if="Orders?.records">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2" style="font-family: Tahoma">آخرین تراکنش ها</h6>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center" style="font-family: Tahoma">
                  <tbody>
                    <tr v-for="(item, index) in Orders?.records" :key="index">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <p class="mb-0 text-sm font-weight-bold">{{formatDateString(item?.CreateOn)}}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-sm font-weight-bold" style="max-width: 300px; word-break: break-word; overflow-wrap: break-word; white-space: normal;">{{productLabel(item?.Items)}}</p>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-sm font-weight-bold">£{{ toCurrencyFormat(item?.Price) }}</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <el-empty description="هیچ تراکنشی ثبت نشده است" v-if="!Orders?.records" style="font-family: Tahoma"/>
          </div>
          <div class="col-lg-5">
            <categories-list
                @select-project="SelectPro"
                v-if="ProShares"
              :categories="ProShares"
            />
            <el-empty description="شما هنوز سهام از پروژه ای ندارید" v-if="!ProShares" style="font-family: Tahoma"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
